
export function formatEntryPlanId(id: number): string {
    return `#EP-${id.toString().padStart(5, '0')}`;
}

export default formatEntryPlanId;
